// extracted by mini-css-extract-plugin
export default {"OrderedList":"OrderedList-module--OrderedList--Xrzzb"};